import { useEffect } from "react";
import { applyTheme } from "../lib/theme";
import { useSettings } from "../lib/settings";

export default function AdminThemeProvider({ children }) {
  const { settings } = useSettings();
  useEffect(() => {
    applyTheme({ primary: settings?.primary_color, secondary: settings?.secondary_color });
  }, [settings?.primary_color, settings?.secondary_color]);
  return children;
}
